import defaultV2Client from '@/plugins/axios/defaultV2Client'
import qs from 'query-string'

export default {
  getPlansRequest(query) {
    return defaultV2Client.get(`/plans/change-requests?${qs.stringify(query)}`)
  },
}
